import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Animations } from '../../animations';
import { GroupMember } from '../../models';

/**
 * Display an array of group members in a table view
 */
@Component({
    selector: 'group-members',
    templateUrl: './group-members.component.html',
    styleUrls: ['./group-members.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [Animations.slideFromRight(100)]
})
export class GroupMembersComponent {
    /** The array of group members to display */
    @Input() set members(members: GroupMember[]) {
        this._members = members?.sort((a, b) => a.key == this.currentUserKey ? -1 : 1);
    }
    /** Key for the current user */
    @Input() currentUserKey: string = '';
    /** Flag to determine whether to reflect `GroupMemberState` */
    @Input() showGroupMemberState: boolean = false;
    /** Key for the group's current quiz/challenge. If provided, points will be displayed in the view */
    @Input() currentChallengeKey: string = null;
    /** Emits when the user requests the removal of another group member. Parameter is the user key of the member to remove. */
    @Output() removeMemberEvent = new EventEmitter<string>();

    /** Group members */
    public _members: GroupMember[] = [];
    /** User key for the currently open member menu */
    public activeMemberKey: string = '';

    constructor() { }

    public openMemberMenu(userKey: string): void {
        this.activeMemberKey = userKey;
    }

    public closeMemberMenu(userKey: string) {
        if(this.activeMemberKey == userKey)
            this.activeMemberKey = '';
    }

    public removeMember(userKey: string): void {
        this.removeMemberEvent.emit(userKey);
        this.activeMemberKey = '';
    }

    public trackByUserKey(index: number, groupMember: GroupMember): string {
        return groupMember.key;
    }
}
